import script from "./AccountGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountGroups.vue?vue&type=script&setup=true&lang=js"

import "./AccountGroups.vue?vue&type=style&index=0&id=84f96174&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84f96174"]])

export default __exports__